import { render, staticRenderFns } from "./PostDetailsHeader.vue?vue&type=template&id=071a7cbc&scoped=true"
import script from "./PostDetailsHeader.vue?vue&type=script&lang=js"
export * from "./PostDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./PostDetailsHeader.vue?vue&type=style&index=0&id=071a7cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071a7cbc",
  null
  
)

export default component.exports